import React from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import TLinkApi from "services/tlink.api";
import { useSnackbar } from "notistack";
import {
  Backdrop,
  CircularProgress,
  FormControlLabel,
  Icon,
  IconButton,
  Switch,
} from "@mui/material";
import { useForm } from "react-hook-form";
import MDTypography from "components/MDTypography";

const IntegrationConfig = () => {
  const navigate = useNavigate();
  const { vendor, setVendor, isEdit, setIsEdit } = useOutletContext();
  let { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [dataEdit, setDataEdit] = useState(false);
  const { id } = useParams();

  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
    setValue,
    register,
    reset,
  } = useForm({
    defaultValues: {
      id: "",
      api_integration_available: false,
      api_integration_enabled: false,
      api_integration_enabled_at: "",
      api_integration_note: "",
      api_integration_close_all: false,
      api_integration_expose_surveys: false,
    },
  });

  useEffect(() => {
    getData();
  }, [vendor]);

  async function getData() {
    setIsLoading(true);
    if (id) {
      try {
        let result = await TLinkApi.get(`/vendors/${id}/integration/config`);
        console.log(result, "result");
        if (result.status !== 404 && Object.keys(result.data).length > 0) {
          setDataEdit(true);
          let payload = {
            id: result.data.id,
            api_integration_available: result.data.api_integration_available,
            api_integration_enabled: result.data.api_integration_enabled,
            api_integration_enabled_at: result.data.api_integration_enabled_at,
            api_integration_note: result.data.api_integration_note,
            api_integration_close_all: result.data.api_integration_close_all,
            api_integration_expose_surveys:
              result.data.api_integration_expose_surveys,
          };
          reset(payload)
        } else {
          setDataEdit(false);
        }
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
      }
    }
  }

  const save = async (data) => {
    setIsLoading(true);

    try {
      if (dataEdit === true) {
        let payloadId = data.id;

        let put_payload = {
          api_integration_available: data.api_integration_available,
          api_integration_enabled: data.api_integration_enabled,
          api_integration_enabled_at: data.api_integration_enabled_at,
          api_integration_note: data.api_integration_note,
          api_integration_close_all: data.api_integration_close_all,
          api_integration_expose_surveys: data.api_integration_expose_surveys,
        };

        let result = await TLinkApi.put(
          `/vendors/${id}/integration/config/${payloadId}`,
          put_payload
        );
        setIsLoading(false);
        setVendor({});
        getData();
        // navigate("/vendors");
        enqueueSnackbar(result?.message, {
          variant: "success",
        });
      } else {
        let post_payload = {
          api_integration_available: data.api_integration_available,
          api_integration_enabled: data.api_integration_enabled,
          api_integration_enabled_at: data.api_integration_enabled_at,
          api_integration_note: data.api_integration_note,
          api_integration_close_all: data.api_integration_close_all,
          api_integration_expose_surveys: data.api_integration_expose_surveys,
        };

        let result = await TLinkApi.post(
          `vendors/${id}/integration/config`,
          post_payload
        );
        setIsLoading(false);
        enqueueSnackbar(result?.message, {
          variant: "success",
        });
        getData();
        setVendor({});
        // navigate("/vendors");
      }
    } catch (e) {
      setIsLoading(false);
      enqueueSnackbar(e?.message, {
        variant: "error",
      });
    }
  };

  function convertToLocalDatetimeInputFormat(isoDateStr) {
    if (!isoDateStr) {
      return "";
    }
    const date = new Date(isoDateStr);
    const offsetMs = date.getTimezoneOffset() * 60000;
    const localDate = new Date(date.getTime() - offsetMs);
    return localDate.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
  }

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <form onSubmit={handleSubmit(save)} noValidate>
        <Grid container spacing={3} px={2}>
          <Grid item xs={12} md={12}></Grid>
        </Grid>
        <MDBox
          p={2}
          style={{
            border: "1px solid #D9D9D9",
            backgroundColor: "white",
            borderRadius: "16px",
          }}
          m={2}
        >
          <MDBox
            px={2}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MDBox>
              {isEdit.disabled === true && (
                <IconButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={() => {
                    setIsEdit({
                      disabled: false,
                      edit: true,
                    });
                  }}
                >
                  <Icon>border_color_icon</Icon>
                </IconButton>
              )}
            </MDBox>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={2.5}>
              <FormControlLabel
                control={
                  <Switch
                    disabled={isEdit.disabled}
                    checked={watch("api_integration_available")}
                    onChange={(e, value) => {
                      setValue("api_integration_available", value);
                    }}
                  />
                }
                label={
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;API Integration Available&nbsp;
                  </MDTypography>
                }
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControlLabel
                control={
                  <Switch
                    disabled={isEdit.disabled}
                    checked={watch("api_integration_enabled")}
                    onChange={(e, value) => {
                      setValue("api_integration_enabled", value);
                       const now = new Date();

                      // Correct local formatting:
                      const localDatetimeFormatted = new Date(
                        now.getTime() - now.getTimezoneOffset() * 60000
                      )
                        .toISOString()
                        .slice(0, 16); // "YYYY-MM-DDTHH:MM"

                      setValue(
                        "api_integration_enabled_at",
                        localDatetimeFormatted
                      );
                    }}
                  />
                }
                label={
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;API Integration is Enabled&nbsp;
                  </MDTypography>
                }
              />
            </Grid>
              <Grid item xs={12} md={2}>
              <MDInput
                disabled
                value={convertToLocalDatetimeInputFormat(
                  watch("api_integration_enabled_at")
                )}
                label="Api Integration Enabled At"
                InputProps={{
                  sx: {
                    "& input::-webkit-calendar-picker-indicator": {
                      display: "none",
                      WebkitAppearance: "none",
                    },
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
                type="datetime-local"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid itex xs={12} md={5.5}></Grid>
            <Grid item xs={12} md={2.5}>
              <FormControlLabel
                control={
                  <Switch
                    disabled={isEdit.disabled}
                    checked={watch("api_integration_close_all")}
                    onChange={(e, value) => {
                      setValue("api_integration_close_all", value);
                    }}
                  />
                }
                label={
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;Close All Surveys on Supplier Platform&nbsp;
                  </MDTypography>
                }
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Switch
                    disabled={isEdit.disabled}
                    checked={watch("api_integration_expose_surveys")}
                    onChange={(e, value) => {
                      setValue("api_integration_expose_surveys", value);
                    }}
                  />
                }
                label={
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;Expose Surveys via Supplier API&nbsp;
                  </MDTypography>
                }
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <MDInput
                multiline
                rows={5}
                label="Note"
                value={watch("api_integration_note")}
                fullWidth
                disabled={isEdit.disabled}
                type="string"
                variant="outlined"
                {...register("api_integration_note", {
                  required: false,
                })}
                placeholder="Note"
              />
            </Grid>
          </Grid>
        </MDBox>

        {isEdit.disabled !== true && (
          <MDBox
            pt={2}
            px={2}
            mb={4}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap="10px"
          >
            <MDButton
              variant="outlined"
              color="dark"
              onClick={() => {
                setIsEdit({
                  disabled: false,
                  edit: false,
                });
                setVendor({});
                navigate("/vendors");
              }}
            >
              &nbsp;cancel
            </MDButton>
            <MDButton variant="gradient" color="info" type="submit">
              Save
            </MDButton>
          </MDBox>
        )}
      </form>
      {isEdit.disabled === true && (
        <MDBox
          py={2}
          px={2}
          mb={4}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          gap="10px"
        >
          <MDButton
            variant="outlined"
            color="dark"
            onClick={() => {
              setIsEdit({
                disabled: false,
                edit: false,
              });
              setVendor({});
              navigate("/vendors");
            }}
          >
            &nbsp;cancel
          </MDButton>
          <MDButton
            variant="gradient"
            color="info"
            onClick={() => {
              setIsEdit({
                disabled: false,
                edit: false,
              });
              setVendor({});
              navigate("/vendors");
            }}
          >
            Save
          </MDButton>
        </MDBox>
      )}
    </>
  );
};

export default IntegrationConfig;
